module.exports = __webpack_public_path__ + "img/x22.16efbc67.jpg";